"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDecorator = exports.LegacyServiceIdCache = void 0;
var add_parameter_meta_1 = require("../metadata/add-parameter-meta");
var metadata_keys_1 = require("../metadata/metadata-keys");
var error_messages_1 = require("../constants/error-messages");
/**
 * 用于缓存构造函数参数装饰器
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var LegacyServiceIdCache = /** @class */ (function () {
    function LegacyServiceIdCache() {
    }
    LegacyServiceIdCache.has = function (id) {
        return this.serviceIdsMap.has(id);
    };
    LegacyServiceIdCache.get = function (id) {
        return this.serviceIdsMap.get(id);
    };
    LegacyServiceIdCache.set = function (id, serviceIdentifier) {
        this.serviceIdsMap.set(id, serviceIdentifier);
    };
    LegacyServiceIdCache.serviceIdsMap = new Map();
    return LegacyServiceIdCache;
}());
exports.LegacyServiceIdCache = LegacyServiceIdCache;
/**
 * 创建一个装饰器，模块的ID就是一个装饰器
 * @param serviceId
 */
function createDecorator(serviceId) {
    if (LegacyServiceIdCache.has(serviceId)) {
        return LegacyServiceIdCache.get(serviceId);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line func-names
    var legacyIdentifier = function (target, key, index) {
        if (arguments.length !== 3) {
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.SERVICE_NAME_DECORATOR_MISUSE(key));
        }
        // 保存依赖关系
        add_parameter_meta_1.addTypeParameterMeta(metadata_keys_1.CLASS_CONSTRUCTOR_DEPS, target, undefined, legacyIdentifier, index);
    };
    // 标记id为Legacy
    legacyIdentifier.toLegacyString = function () { return serviceId; };
    LegacyServiceIdCache.set(serviceId, legacyIdentifier);
    return legacyIdentifier;
}
exports.createDecorator = createDecorator;
//# sourceMappingURL=legacy-deps.js.map